module.exports = __webpack_public_path__ + "static/media/20210410_174737_692_IMG_0257.2ce36338.jpg";